<template>
    <BarometerBanner :title="title" :cta="cta" :cta2="cta2" />
</template>

<script setup lang="ts">
    import {useTranslation} from '#imports';
    import BarometerBanner from '../BarometerBanner.vue';

    const {t} = useTranslation();

    const title = t('barometer.banners.user.not.connected.title');
    const cta = {url: '/', label: t('barometer.banners.user.not.connected.find.freelance')};
    const cta2 = {url: '/c/freelancers', label: t('barometer.banners.user.not.connected.find.missions')};
</script>
